module.exports = __webpack_public_path__ + "static/img/stage-info.5a36183.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/aboutus/stage-info.png
// module id = wBnV
// module chunks = 44